
<template>
  
  <v-app id="settlingHosts">
    <v-main>

    <v-container fluid>
     
      <v-row dense no-gutters>
         
           <v-col cols="2" class="mx-2">
            <v-checkbox v-model="settle" label="Settle bookings"></v-checkbox>
          </v-col>
      </v-row>

      <v-row>
          <v-col cols="1">
            <v-btn class="primary ma-0"  small @click="getHuov">Search</v-btn>
          </v-col> 
      </v-row>

      </v-container> 


     <v-container fluid>
      <v-row v-if="results" dense no-gutters>
        <v-card class="px-2">
         
            <v-text-field
            v-model="search"
              label="Search"
              single-line
              hide-details
             >
            </v-text-field>
        
            <v-data-table 
            :items="items" 
            :items-per-page="200" 
            :footer-props="{'items-per-page-options': [50, 100, 200, 300, 500]}"
            :headers="headers"
            :search="search"        
            >
            <template v-slot:item="props">
              <tr>
              <td>{{props.item.eign_naam}} </td>  
              <td @click="$router.open('/huov/onHuov/' + props.item.huov_encrid_van)"><a> {{props.item.huov_code_van}} </a></td>
              <td @click="$router.open('/huov/onHuov/' + props.item.huov_encrid_naar)"><a> {{props.item.huov_code_naar}} </a></td>
              <td align="right">{{props.item.bedrag}} </td>
              </tr>
            </template>
            </v-data-table>
        </v-card>
        </v-row>
     </v-container>
    
    </v-main>
    <showProgress ref="showProgress"></showProgress>
    <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import showProgress from "@/components/showProgress.vue";
 export default {
  components: {
    navBar,
    showProgress
  },
  data() {
    return {
      items: [],
      results: false,
      settle: false,
      search: '',
      headers: [
        {text: 'Host', value: 'eign_naam'},
        {text: 'From Booking', value: 'huov_code_van'},
        {text: 'To Booking', value: 'huov_code_naar'},
        {text: 'Amount', align: 'end', value: 'bedrag'}
      ]
    }

  },
  methods: {
     getHuov() {
      this.results = true;
      this.$refs.showProgress.open();
      this.$axios
        .post("ares/json/ares/task/fin/abn/settlingHosts.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "settlingHosts"
          },
          settlingHosts: {
             settle: this.settle,
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.settlingHosts;
            this.$refs.showProgress.close();
          }
        })
        .finally(() => {
          this.loading = false;
        });
  }
  }
  
}

</script> 
